<template>
  <div :class="'col-md-' + col">
    <div class="col-md-12 box-tools">
      <div class="box-tools__title col-md-12" v-on:click="openCard()">
        <p>
          {{ title }}
          <span>
            <ion-icon :style="{ transform: openingCard ? 'rotate(180deg)' : 'none' }" name="chevron-down-outline" />
          </span>
        </p>
      </div>
      <transition name="slide-fade">
        <div v-if="openingCard" class="col-xs-12 col-sm-12 col-md-12 btn-open">
          <slot />
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: "miniCardDetails",
  props: {
    title: {
      required: true,
    },
    col: {
      default: 12
    },
  },
  data() {
    return {
      openingCard: false,
    }
  },
  methods: {
    openCard() {
      this.openingCard = !this.openingCard;
    }
  }
}
</script>

<style lang="scss">

* {
  font-family: "Montserrat", sans-serif !important;
}

.box-tools {
  border: 1px solid rgba(230,230,230,.8980392157)!important;
  background-color: #FFFFFF;
  padding: 8px 24px;
  box-shadow: 2px 2px 2px 0px rgba(0, 0, 0, 0.07);
  border-radius: 16px !important;

  &__title {
  margin: 0 !important;
  padding: 0 !important;
  min-height: fit-content !important;
  cursor: pointer;

  p {
    text-transform: capitalize !important;
    display: flex !important;
    align-items: center;
    justify-content: space-between;
    font-size: 16px !important;
    font-style: normal !important;
    font-weight: 600 !important;
    line-height: 125.303% !important;
    color: #3A424E !important;
    height: 40px;
    margin: 0 !important;

    span {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 40px;
      width: 40px;
      border-bottom: none !important;

      ion-icon {
        pointer-events: none;
        color: #1b59f8;
        font-size: 32px;
        transition: .2s;
      }
    }
  }
}
}

</style>


// WEBPACK FOOTER //
// src/vue/pages/components/layouts/boxDropDown.vue